/*
const TOUR_ROUTE_COLOR_FROM = '#3b00d2'
const TOUR_ROUTE_COLOR_TO = '#ff64bb'
const TOUR_ROUTE_STROKE_OPACITY = 1
const TOUR_ROUTE_STROKE_WEIGHT = 6
const TOUR_ROUTE_HOVER_MULTIPLIER = 1.8

const TOUR_ROUTE_OTHER_COLOR = '#b489d7'

let tourRoutePolylines = []
let tourRouteActiveIndex = null
let tourIgnoreNextMapClick = false
let tourMapClickBound = false

const TOUR_PREFER_ROADS_DEFAULT = false
const TOUR_PREFER_ROADS_PENALTY_WORDS = ['fußweg', 'fussweg', 'pfad', 'trampelpfad', 'wanderweg', 'treppe', 'stufen', 'durchgang', 'passage', 'innen', 'indoor', 'park', 'promenade', 'uferweg', 'brücke', 'bruecke']

function haversineMetersPos(a, b) {
	const R = 6371000
	const toRad = (x) => x * Math.PI / 180
	const dLat = toRad(b.lat - a.lat)
	const dLng = toRad(b.lng - a.lng)
	const lat1 = toRad(a.lat)
	const lat2 = toRad(b.lat)
	const s1 = Math.sin(dLat / 2)
	const s2 = Math.sin(dLng / 2)
	const h = s1 * s1 + Math.cos(lat1) * Math.cos(lat2) * s2 * s2
	return 2 * R * Math.asin(Math.sqrt(h))
}

function hexToRgb(hex) {
	hex = (hex || '').toString().replace('#', '').trim()
	if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
	if (hex.length !== 6) return { r: 0, g: 0, b: 0 }
	const n = parseInt(hex, 16)
	return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 }
}

function rgbToHex(r, g, b) {
	const to2 = (v) => {
		const s = Math.max(0, Math.min(255, Math.round(v))).toString(16)
		return s.length === 1 ? '0' + s : s
	}
	return '#' + to2(r) + to2(g) + to2(b)
}

function colorBetweenAtT(hexA, hexB, t) {
	const a = hexToRgb(hexA)
	const b = hexToRgb(hexB)
	t = Math.max(0, Math.min(1, Number(t) || 0))
	return rgbToHex(a.r + (b.r - a.r) * t, a.g + (b.g - a.g) * t, a.b + (b.b - a.b) * t)
}

function getRouteColor(seed, idx, total) {
	const denom = Math.max(1, Number(total) || 1)
	const t = (Number(seed) + (Number(idx) || 0) / denom) % 1
	return colorBetweenAtT(TOUR_ROUTE_COLOR_FROM, TOUR_ROUTE_COLOR_TO, t)
}

function getPos(entry) {
	const p = entry.marker.getPosition()
	return { lat: p.lat(), lng: p.lng() }
}

function normalizeTourCfg(cfg) {
	const maxDistanceKm = Number(cfg.max_distance || 0)
	const maxDistanceStepKm = Number(cfg.max_distance_step || 0)
	const maxWalktimeMin = Number(cfg.max_walktime || 0)
	const maxWalktimeStepMin = Number(cfg.max_walktime_step || 0)
	const maxPoints = Math.max(0, parseInt(cfg.max_points, 10) || 0)
	const minPoints = Math.max(0, parseInt(cfg.min_points, 10) || 0)
	const preferRoads = typeof cfg.prefer_roads === 'undefined' ? TOUR_PREFER_ROADS_DEFAULT : !!cfg.prefer_roads

	return {
		minPoints,
		maxPoints,
		maxDistanceM: maxDistanceKm > 0 ? maxDistanceKm * 1000 : 0,
		maxDistanceStepM: maxDistanceStepKm > 0 ? maxDistanceStepKm * 1000 : 0,
		maxWalktimeS: maxWalktimeMin > 0 ? maxWalktimeMin * 60 : 0,
		maxWalktimeStepS: maxWalktimeStepMin > 0 ? maxWalktimeStepMin * 60 : 0,
		preferRoads
	}
}

function estimateWalkSeconds(meters) {
	return meters / 1.4
}

function pickFarthestSeed(points, chosen) {
	let bestIdx = -1
	let bestScore = -1
	for (let i = 0; i < points.length; i++) {
		if (points[i].used) continue
		let minD = Infinity
		for (let c = 0; c < chosen.length; c++) {
			const d = haversineMetersPos(points[i].pos, points[chosen[c]].pos)
			if (d < minD) minD = d
		}
		if (minD > bestScore) {
			bestScore = minD
			bestIdx = i
		}
	}
	return bestIdx
}

function buildInitialRoutes(points, k) {
	const routes = []
	if (!points.length) return routes

	const chosen = []
	let first = -1
	for (let i = 0; i < points.length; i++) {
		if (!points[i].used) {
			first = i
			break
		}
	}
	if (first === -1) return routes

	chosen.push(first)
	points[first].used = true

	while (chosen.length < k && chosen.length < points.length) {
		const next = pickFarthestSeed(points, chosen)
		if (next === -1) break
		chosen.push(next)
		points[next].used = true
	}

	for (let i = 0; i < chosen.length; i++) {
		routes.push({
			pointIdxs: [chosen[i]],
			distM: 0,
			timeS: 0,
			closed: false
		})
	}
	return routes
}

function routeLoadScore(r) {
	return r.distM + r.timeS
}

function findBestNextPoint(points, route, cfg) {
	const lastIdx = route.pointIdxs[route.pointIdxs.length - 1]
	const lastPos = points[lastIdx].pos

	let best = -1
	let bestD = Infinity

	for (let i = 0; i < points.length; i++) {
		if (points[i].used) continue

		const d = haversineMetersPos(lastPos, points[i].pos)
		if (cfg.maxDistanceStepM && d > cfg.maxDistanceStepM) continue

		const stepTime = estimateWalkSeconds(d)
		if (cfg.maxWalktimeStepS && stepTime > cfg.maxWalktimeStepS) continue

		const newDist = route.distM + d
		const newTime = route.timeS + stepTime

		if (cfg.maxDistanceM && newDist > cfg.maxDistanceM) continue
		if (cfg.maxWalktimeS && newTime > cfg.maxWalktimeS) continue

		if (d < bestD) {
			bestD = d
			best = i
		}
	}

	return best
}

function buildBalancedRoutes(markerEntries, cfg) {
	const points = markerEntries.map((e) => ({
		entry: e,
		pos: getPos(e),
		used: false
	}))

	const maxPoints = cfg.maxPoints || 0
	if (!maxPoints) return []

	const baseK = Math.max(1, Math.ceil(points.length / maxPoints))
	const routes = buildInitialRoutes(points, baseK)

	let progress = true
	while (progress) {
		progress = false

		let bestRouteIdx = -1
		let bestScore = Infinity

		for (let r = 0; r < routes.length; r++) {
			const route = routes[r]
			if (route.closed) continue
			if (route.pointIdxs.length >= maxPoints) {
				route.closed = true
				continue
			}
			const s = routeLoadScore(route)
			if (s < bestScore) {
				bestScore = s
				bestRouteIdx = r
			}
		}

		if (bestRouteIdx === -1) break

		const route = routes[bestRouteIdx]
		const nextIdx = findBestNextPoint(points, route, cfg)
		if (nextIdx === -1) {
			route.closed = true
			continue
		}

		const prevIdx = route.pointIdxs[route.pointIdxs.length - 1]
		const d = haversineMetersPos(points[prevIdx].pos, points[nextIdx].pos)
		const t = estimateWalkSeconds(d)

		route.pointIdxs.push(nextIdx)
		route.distM += d
		route.timeS += t
		points[nextIdx].used = true
		progress = true
	}

	const leftovers = []
	for (let i = 0; i < points.length; i++) {
		if (!points[i].used) leftovers.push(i)
	}
	for (let i = 0; i < leftovers.length; i++) {
		routes.push({
			pointIdxs: [leftovers[i]],
			distM: 0,
			timeS: 0,
			closed: true
		})
	}

	return routes.map((r) => r.pointIdxs.map((idx) => points[idx].entry))
}

function enforceMinPoints(routes, cfg) {
	const minPoints = Math.max(0, Number(cfg && cfg.minPoints) || 0)
	const maxPoints = Math.max(0, Number(cfg && cfg.maxPoints) || 0)
	if (!minPoints || routes.length <= 1) return routes

	const clones = routes.map((r) => (r || []).slice())

	const centroid = (entries) => {
		let lat = 0
		let lng = 0
		let n = 0
		for (let i = 0; i < entries.length; i++) {
			const p = getPos(entries[i])
			lat += p.lat
			lng += p.lng
			n += 1
		}
		return n ? { lat: lat / n, lng: lng / n } : { lat: 0, lng: 0 }
	}

	const distance = (a, b) => haversineMetersPos(a, b)

	let changed = true
	while (changed) {
		changed = false

		let smallIdx = -1
		for (let i = 0; i < clones.length; i++) {
			if (clones[i].length && clones[i].length < minPoints) {
				smallIdx = i
				break
			}
		}
		if (smallIdx === -1) break

		const small = clones[smallIdx]
		if (!small.length) {
			clones.splice(smallIdx, 1)
			changed = true
			continue
		}

		const cSmall = centroid(small)
		let bestIdx = -1
		let bestD = Infinity
		let bestCapacity = -Infinity

		for (let i = 0; i < clones.length; i++) {
			if (i === smallIdx) continue
			if (!clones[i].length) continue

			const cap = maxPoints ? (maxPoints - clones[i].length) : Infinity
			const cBig = centroid(clones[i])
			const d = distance(cSmall, cBig)

			if (cap >= small.length) {
				if (d < bestD) {
					bestD = d
					bestIdx = i
					bestCapacity = cap
				}
			} else {
				if (bestIdx === -1 && cap > bestCapacity) {
					bestCapacity = cap
					bestIdx = i
					bestD = d
				}
			}
		}

		if (bestIdx === -1) break

		clones[bestIdx] = clones[bestIdx].concat(small)
		clones.splice(smallIdx, 1)
		changed = true
	}

	return clones
}

function reorderListByRoutes(routes) {
	const $list = $('.tour .list').first()
	if (!$list.length) return

	const seen = {}
	const ordered = []

	for (let r = 0; r < routes.length; r++) {
		const entries = routes[r]
		for (let i = 0; i < entries.length; i++) {
			const $item = entries[i] && entries[i].$item
			if (!$item || !$item.length) continue
			const id = $item.data('id')
			const key = id === undefined || id === null ? '' : String(id)
			if (!key || seen[key]) continue
			seen[key] = true
			ordered.push($item)
		}
	}

	for (let i = 0; i < ordered.length; i++) {
		$list.append(ordered[i])
	}

	$list.find('.call').each(function () {
		const $item = $(this)
		const id = $item.data('id')
		const key = id === undefined || id === null ? '' : String(id)
		if (!key || seen[key]) return
		seen[key] = true
		$list.append($item)
	})
}

function stripHtml(s) {
	return (s || '').toString().replace(/<[^>]*>/g, ' ')
}

function scoreDirectionsRoute(route) {
	let penalty = 0
	let durationS = 0
	if (route && route.legs && route.legs.length) {
		for (let i = 0; i < route.legs.length; i++) {
			const leg = route.legs[i]
			if (leg && leg.duration && typeof leg.duration.value === 'number') durationS += leg.duration.value
			if (leg && leg.steps && leg.steps.length) {
				for (let j = 0; j < leg.steps.length; j++) {
					const step = leg.steps[j]
					const txt = stripHtml(step && step.instructions ? step.instructions : '').toLowerCase()
					for (let k = 0; k < TOUR_PREFER_ROADS_PENALTY_WORDS.length; k++) {
						if (txt.indexOf(TOUR_PREFER_ROADS_PENALTY_WORDS[k]) !== -1) penalty += 1
					}
				}
			}
		}
	}
	return { penalty, durationS }
}

function pickPreferredDirectionsResult(result) {
	if (!result || !result.routes || !result.routes.length) return result

	let bestIdx = 0
	let best = scoreDirectionsRoute(result.routes[0])

	for (let i = 1; i < result.routes.length; i++) {
		const s = scoreDirectionsRoute(result.routes[i])
		if (s.penalty < best.penalty || (s.penalty === best.penalty && s.durationS < best.durationS)) {
			best = s
			bestIdx = i
		}
	}

	if (bestIdx === 0) return result
	const picked = Object.assign({}, result)
	picked.routes = [result.routes[bestIdx]]
	return picked
}

function resetTourPolylines() {
	for (let i = 0; i < tourRoutePolylines.length; i++) {
		const p = tourRoutePolylines[i] && tourRoutePolylines[i].polyline
		if (p) p.setMap(null)
	}
	tourRoutePolylines = []
	tourRouteActiveIndex = null
}

function scrollListToFirstEntry($list, $item) {
	if (!$item || !$item.length) return

	if ($list && $list.length) {
		const top = ($item.position() ? $item.position().top : 0)
		if (isFinite(top)) {
			const target = Math.max(0, $list.scrollTop() + top - 16)
			try {
				$list.stop(true).animate({ scrollTop: target }, 250)
			} catch (e) {
				$list.scrollTop(target)
			}
		}
	}

	try {
		$('html, body').stop(true).animate({ scrollTop: Math.max(0, $item.offset().top - 120) }, 250)
	} catch (e) {
		window.scrollTo(0, Math.max(0, $item.offset().top - 120))
	}
}

function applyRouteFilter(routeIndex, entries) {
	tourRouteActiveIndex = Number(routeIndex) || 0

	const $list = $('.tour .list').first()
	const allowed = {}
	for (let i = 0; i < entries.length; i++) {
		const $it = entries[i] && entries[i].$item
		if (!$it || !$it.length) continue
		const id = $it.data('id')
		const key = id === undefined || id === null ? '' : String(id)
		if (key) allowed[key] = true
	}

	$list.find('.call').each(function () {
		const $it = $(this)
		const id = $it.data('id')
		const key = id === undefined || id === null ? '' : String(id)
		if (key && allowed[key]) {
			$it.removeClass('muted')
		} else {
			$it.addClass('muted')
		}
	})

	if (entries[0] && entries[0].$item) {
		scrollListToFirstEntry($list, entries[0].$item)
	}

	for (let i = 0; i < tourRoutePolylines.length; i++) {
		const r = tourRoutePolylines[i]
		if (!r || !r.polyline) continue
		if (r.routeIndex === tourRouteActiveIndex) {
			r.polyline.setOptions({ strokeColor: r.color, strokeOpacity: TOUR_ROUTE_STROKE_OPACITY })
		} else {
			r.polyline.setOptions({ strokeColor: TOUR_ROUTE_OTHER_COLOR, strokeOpacity: TOUR_ROUTE_STROKE_OPACITY })
		}
	}
}

function clearRouteFilter() {
	tourRouteActiveIndex = null

	const $list = $('.tour .list').first()
	$list.find('.call').removeClass('muted')

	for (let i = 0; i < tourRoutePolylines.length; i++) {
		const r = tourRoutePolylines[i]
		if (!r || !r.polyline) continue
		r.polyline.setOptions({ strokeColor: r.color, strokeOpacity: TOUR_ROUTE_STROKE_OPACITY })
	}
}

function renderDirectionsRoute(directionsService, map, entries, strokeColor, cfg, routeIndex, done) {
	if (!entries || entries.length < 2) {
		done()
		return
	}

	const origin = entries[0].marker.getPosition()
	const destination = entries[entries.length - 1].marker.getPosition()
	const waypoints = []

	for (let i = 1; i < entries.length - 1; i++) {
		waypoints.push({ location: entries[i].marker.getPosition(), stopover: false })
	}

	directionsService.route(
		{
			origin,
			destination,
			waypoints,
			travelMode: google.maps.TravelMode.WALKING,
			optimizeWaypoints: false,
			provideRouteAlternatives: !!(cfg && cfg.preferRoads)
		},
		(result, status) => {
			if (status === 'OK' && result) {
				const picked = cfg && cfg.preferRoads ? pickPreferredDirectionsResult(result) : result
				const route = picked && picked.routes && picked.routes[0]
				if (route && route.overview_path && route.overview_path.length) {
					const baseWeight = TOUR_ROUTE_STROKE_WEIGHT
					const hoverWeight = baseWeight * TOUR_ROUTE_HOVER_MULTIPLIER
					const baseZ = 10 + (Number(routeIndex) || 0)

					const polyline = new google.maps.Polyline({
						map,
						path: route.overview_path,
						strokeColor: strokeColor || TOUR_ROUTE_COLOR_FROM,
						strokeOpacity: TOUR_ROUTE_STROKE_OPACITY,
						strokeWeight: baseWeight,
						zIndex: baseZ,
						clickable: true
					})

					tourRoutePolylines.push({
						routeIndex: Number(routeIndex) || 0,
						polyline: polyline,
						color: strokeColor || TOUR_ROUTE_COLOR_FROM,
						baseZ: baseZ
					})

					polyline.addListener('mouseover', function () {
						polyline.setOptions({ strokeWeight: hoverWeight, zIndex: 9999 })
					})

					polyline.addListener('mouseout', function () {
						polyline.setOptions({ strokeWeight: baseWeight, zIndex: baseZ })
					})

					polyline.addListener('click', function (ev) {
						tourIgnoreNextMapClick = true
						setTimeout(function () { tourIgnoreNextMapClick = false }, 0)

						const payload = {
							routeIndex: Number(routeIndex) || 0,
							entries: entries,
							color: strokeColor || TOUR_ROUTE_COLOR_FROM,
							event: ev,
							polyline: polyline
						}
						if (typeof window.onTourRouteClick === 'function') window.onTourRouteClick(payload)
						if (window.jQuery) $(window).trigger('tour:routeClick', [payload])

						applyRouteFilter(routeIndex, entries)
					})
				}
			}
			done()
		}
	)
}

function initTourDirections(map, markerEntries) {
	const cfg = normalizeTourCfg(window.tourCfg || {})
	if (!cfg.maxPoints || !markerEntries || markerEntries.length < 2) return
	if (!google || !google.maps || !google.maps.DirectionsService) return

	resetTourPolylines()

	if (!tourMapClickBound) {
		tourMapClickBound = true
		map.addListener('click', function () {
			if (tourIgnoreNextMapClick) return
			if (tourRouteActiveIndex === null) return
			clearRouteFilter()
		})
	}

	const routes = buildBalancedRoutes(markerEntries, cfg)
	const routesMin = enforceMinPoints(routes, cfg)
	if (!routesMin.length) return

	reorderListByRoutes(routesMin)

	const routeColorSeed = Math.random()
	const totalRoutes = routesMin.length

	const directionsService = new google.maps.DirectionsService()
	let i = 0

	const next = () => {
		if (i >= routesMin.length) return
		const routeIndex = i
		const strokeColor = getRouteColor(routeColorSeed, routeIndex, totalRoutes)
		const entries = routesMin[i]
		for (let j = 0; j < entries.length; j++) {
			const $item = entries[j] && entries[j].$item
			if ($item && $item.length) {
				$item.removeAttr('data-color')
				$item.css('background-color', strokeColor)
			}
		}
		i += 1
		renderDirectionsRoute(directionsService, map, entries, strokeColor, cfg, routeIndex, () => {
			setTimeout(next, 120)
		})
	}

	next()
}

window.initTourDirections = initTourDirections

window.runTourDirections = function () {
	if (!window.tourState || !window.tourState.map || !window.tourState.markers) return
	window.initTourDirections(window.tourState.map, window.tourState.markers)
}

window.runTourDirections()
*/
